import DatepickerFunctions from "./DatepickerHelper";

export const transformObjectIntegrationLogs = (data, enumStatuses) => {
    return data?.map((item) => {
        return {
            ...item,
            document_number: item?.document_number ?? '-',
            enqueued_at: DatepickerFunctions.convertDateTimeFromDataBase(item?.enqueued_at),
            dequeued_at: DatepickerFunctions.convertDateTimeFromDataBase(item?.dequeued_at),
            status: enumStatuses?.find((obj) => item.status == obj.value)?.label ?? '-'
        }
    })
};
